import { FieldValues, Path, useFormContext } from "react-hook-form";

export const useAutofill = <T extends FieldValues>(name: Path<T>) => {
    const { getValues, setValue } = useFormContext<T>();

    const handleOnAutofill = () => {
        setValue(name, getValues(name), {
            shouldDirty: true
        });
    };

    return { handleOnAutofill: handleOnAutofill };
};
